import api from "@/api/axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { useJwt } from "common-frontend-components";
import { type ReactNode, createContext, useMemo } from "react";

export const CompublishContext = createContext({
    url: "",
});
export default function CompublishProvider({ children }: { children: ReactNode }) {
    const { userId } = useJwt();

    const authenticated = useMemo(() => {
        return !!userId;
    }, [userId]);

    const { data } = useQuery({
        queryKey: ["CompublishUrl"],
        queryFn: async () => (await api.get(`admin/env/compublishUrl`)).data.data,

        staleTime: Infinity,
        enabled: authenticated,
    });
    return (
        <CompublishContext.Provider value={{ url: data }}>{children}</CompublishContext.Provider>
    );
}
